import { Component, inject, OnInit, ChangeDetectionStrategy, output } from '@angular/core';
import { PlexEnvironment } from '@app/env';
import { SVGIcon } from '@progress/kendo-angular-icons';
import { LoaderComponent, LoaderSize, LoaderThemeColor, LoaderType, } from "@progress/kendo-angular-indicators";
import { gearIcon } from "@progress/kendo-svg-icons";
import { ProjectBaseScenarioTabItemComponent } from 'app/cem/project/content/project-base-scenario-tabitem.component';
import { ProjectTypeId } from 'app/shared/data/project-enums';
import { AppScheduleTaskSurfacedevComponent } from '../../schedule/app-schedule-task-surfacedev/app-schedule-task-surfacedev.component';
import { ScheduleTaskComponent } from '../../schedule/schedule-task/schedule-task.component';

@Component({
  selector: 'app-project-schedule',
  templateUrl: './project-schedule.component.html',
  styleUrls: ['./project-schedule.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppScheduleTaskSurfacedevComponent,
    ScheduleTaskComponent,
    LoaderComponent,
  ],
})
export class ProjectScheduleComponent extends ProjectBaseScenarioTabItemComponent implements OnInit {
  public environment = inject(PlexEnvironment);
  public showSchedule: boolean;

  readonly tabTitle = output<string>();
  readonly tabTdv = output<boolean>();

  public loader = {
    type: <LoaderType>'converging-spinner',
    themeColor: <LoaderThemeColor>'info',
    size: <LoaderSize>'large'
  };

  constructor() {
    super();
  }

  ngOnInit() {
    this.showSchedule = this.projectTypeHasSchedule();
  }

  public projectTypeHasSchedule(): boolean {

    if (this.projectTab().ProjectTypeId == ProjectTypeId.PadConstruction) {
      return this.environment.showPadConstructionSchedules;
    }
    return true;
  }

  public icons = {
    gear: <SVGIcon>gearIcon
  };

  public setTDV(): void {
    let newTitle: string = 'WBS-CODING*';
    this.tabTitle.emit(newTitle);
    let tdvState: boolean = true;
    this.tabTdv.emit(tdvState);
  }

  public clearTDV(): void {
    let newTitle: string = 'WBS-CODING';
    this.tabTitle.emit(newTitle);
    let tdvState: boolean = false;
    this.tabTdv.emit(tdvState);
  }
}